Ext.define('WindowPojazdy', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.pojazd.capitalise(),
    width: 950,
    height: 850,
    closable: false,
    collapsible: false,
    scrollable: true,
    modal: true,
    resizable: false,
    licznikstart: null,
    licznikend: null,
    idphotostart: null,
    idphotoend: null,
    isstanylicznikafilled: false,
    wynajem: false,
    layout: 'fit',
    initComponent: function (config) {
        this.cid = Ext.id();
        let formpanel1 = {
            id: this.cid + "formpanel1",
            title: Lang.ogolne.capitalise(),
            xtype: 'form',
            frame: true,
            border: false,
            autoWidth: true,
            scrollable: true,
            autoHeight: true,
            labelWidth: 80,
            bodyStyle: 'padding:10px 10px 0px 10px',
            defaults: {
                anchor: "0",
                labelWidth: 80
            },
            items: [{
                anchor: "0",
                layout: 'column',
                frame: false,
                border: false,
                items: [{
                    columnWidth: WindowExdMobileDEVICEV ? 1 : 0.7,
                    layout: 'anchor',
                    frame: false,
                    border: false,
                    defaults: {
                        anchor: "0",
                        labelWidth: 130,
                        labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left'
                    },
                    items: [{
                        id: this.cid + "nazwa",
                        name: "nazwa",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.nazwa,
                        allowBlank: false,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "eiid",
                        name: "eiid",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.eiid,
                        allowBlank: true,
                        blankText: Lang.pole_nie_moze_byc_puste,
                        hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
                    }, {
                        id: this.cid + "cardname",
                        name: "cardname",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.nazwa_karty,
                        allowBlank: true,
                        editable: true,
                        disabled: true,
                        hidden: true
                    }, {
                        id: this.cid + "rokprodukcji",
                        name: "rokprodukcji",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.rok_produkcji,
                        hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                        allowBlank: true,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "identeuro",
                        name: "identeuro",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.ident_euro,
                        allowBlank: true,
                        blankText: Lang.pole_nie_moze_byc_puste,
                        hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || Const.ENABLEKELLER
                    }, {
                        id: this.cid + "identeuro2",
                        name: "identeuro2",
                        xtype: 'comboexd',
                        fieldLabel: Lang.ident_euro,
                        allowBlank: !Const.POJAZDEUROREQUIRED,
                        blankText: Lang.pole_nie_moze_byc_puste,
                        store: Ext.create('Ext.data.Store', {
                            fields: ['value', 'text'],
                            proxy: {
                                type: 'ajax',
                                url: 'rest/identeuro/getList',
                                actionMethods: {
                                    read: 'POST'
                                },
                                reader: {
                                    type: 'json',
                                    transform: {
                                        fn: function (data) {
                                            return data.map(function (item) {
                                                return {value: item, text: item};
                                            });
                                        },
                                        scope: this
                                    }
                                },
                            },
                            autoLoad: true
                        }),
                        hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || !Const.ENABLEKELLER
                    }, {
                        id: this.cid + "grupa",
                        name: "grupa",
                        style: "margin-top: 10px",
                        fieldLabel: Lang.grupa,
                        allowBlank: !Const.ENABLETRAMWAJE,
                        xtype: 'comboexd',
                        emptyText: Lang.brak_grupy,
                        store: Ext.create('Ext.data.Store', {
                            fields: [{
                                name: 'id',
                                allowNull: true
                            }, 'nazwa'],
                            proxy: {
                                type: 'ajax',
                                url: 'rest/grupy/getList',
                                actionMethods: {
                                    read: 'POST'
                                },
                                extraParams: {
                                    type: Const.GROUP_TYPE_POJAZD
                                },
                                reader: {
                                    type: 'json',
                                    rootProperty: 'data'
                                }
                            },
                            autoLoad: false
                        }),
                        displayField: 'nazwa',
                        valueField: 'id',
                        hidden: Const.STARTERFLAG
                    }, {
                        id: this.cid + "kategoria",
                        name: "kategoria",
                        style: "margin-top: 10px",
                        fieldLabel: Lang.kategoria,
                        xtype: 'comboexd',
                        allowBlank: true,
                        emptyText: Lang.brak_kategorii,
                        store: Ext.create('Ext.data.Store', {
                            fields: [{
                                name: 'id',
                                allowNull: true
                            }, 'nazwa', 'type'],
                            proxy: {
                                type: 'ajax',
                                url: 'rest/kategorie/getList',
                                actionMethods: {
                                    read: 'POST'
                                },
                                reader: {
                                    type: 'json',
                                    rootProperty: 'data'
                                }
                            },
                            autoLoad: false
                        }),
                        listeners: {
                            change: function (combo, newValue) {
                                this.updateIsmotogodzinynotkilometry(combo, newValue);
                            },
                            scope: this
                        },
                        displayField: 'nazwa',
                        valueField: 'id',
                        hidden: Const.STARTERFLAG
                    }, {
                        id: this.cid + "plyn",
                        name: "plyn",
                        style: "margin-top: 10px",
                        fieldLabel: Lang.plyn_gps,
                        allowBlank: true,
                        xtype: 'comboexd',
                        hidden: !Const.ENABLEGPS || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                        emptyText: Lang.brak_plynu,
                        store: Ext.create('Ext.data.Store', {
                            fields: [{
                                name: 'id',
                                allowNull: true
                            }, 'nazwa'],
                            proxy: {
                                type: 'ajax',
                                url: 'rest/plyny/getList',
                                actionMethods: {
                                    read: 'POST'
                                },
                                reader: {
                                    type: 'json',
                                    rootProperty: 'data'
                                }
                            },
                            autoLoad: false
                        }),
                        displayField: 'nazwa',
                        valueField: 'id'
                    }, {
                        id: this.cid + "identflota",
                        name: "identflota",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.ident_flota,
                        allowBlank: true,
                        blankText: Lang.pole_nie_moze_byc_puste,
                        hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || Const.ENTERPRISEFLAG
                    }, {
                        id: this.cid + "localization",
                        name: "localization",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.localization,
                        allowBlank: true,
                        hidden: (!Const.ENABLEGIRTEKA && !Const.ENABLETRAMWAJE),
                        editable: !Const.ENABLETRAMWAJE
                    }, {
                        xtype: 'radiogroupexd',
                        id: this.cid + "active",
                        name: "active",
                        baseCls: 'x-radio-column',
                        fieldLabel: Lang.active,
                        columns: 2,
                        vertical: false,
                        disabled: Const.ENABLETRAMWAJE,
                        items: [{
                            boxLabel: Lang.tak.capitalise(),
                            inputValue: true,
                            value: true
                        }, {
                            boxLabel: Lang.nie.capitalise(),
                            inputValue: false
                        }]
                    }, {
                        xtype: 'radiogroupexd',
                        id: this.cid + "ismotogodzinynotkilometry",
                        name: "ismotogodzinynotkilometry",
                        baseCls: 'x-radio-column',
                        fieldLabel: Lang.typ_pracy,
                        columns: 2,
                        vertical: false,
                        hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                        items: [{
                            boxLabel: Lang.motogodziny.capitalise(),
                            inputValue: true
                        }, {
                            boxLabel: Lang.kilometry.capitalise(),
                            inputValue: false,
                            value: true
                        }],
                        listeners: {
                            change: function (radiogroup, newValue) {
                                if (this.defaultMaxMileageDiff != null) {
                                    if (newValue)
                                        Ext.getCmp(this.cid + "maxmileagediff").setValue(this.defaultMaxMileageDiff.rg);
                                    else
                                        Ext.getCmp(this.cid + "maxmileagediff").setValue(this.defaultMaxMileageDiff.km);
                                }
                            },
                            scope: this
                        }
                    }, {
                        id: this.cid + 'typpojazdu',
                        xtype: 'comboexd',
                        store: TYP_POJAZDU,
                        triggerAction: 'all',
                        resizable: false,
                        mode: "local",
                        editable: true,
                        fieldLabel: Lang.typ_pojazdu,
                        allowBlank: !Const.ENABLETYCHY,
                        hidden: !Const.ENABLETYCHY,
                        listeners: {
                            change: function () {
                                var newValue = Ext.getCmp(this.cid + 'typpojazdu').getValue();
                                if (newValue == Const.TYP_POJAZDU_ZEWNETRZNY) {
                                    Ext.getCmp(this.cid + 'typtaboru').setValue(null);
                                    Ext.getCmp(this.cid + 'typtaboru').setDisabled(true);
                                    if (this.obiektid == 0) {
                                        Ext.getCmp(this.cid + 'active').setDisabled(true);
                                        Ext.getCmp(this.cid + 'active').setValue2(true);
                                    }
                                } else {
                                    Ext.getCmp(this.cid + 'typtaboru').setDisabled(false);
                                    Ext.getCmp(this.cid + 'active').setDisabled(false);
                                }
                            },
                            scope: this
                        }
                    }, {
                        id: this.cid + 'typtaboru',
                        xtype: 'comboexd',
                        store: TYP_TABORU,
                        triggerAction: 'all',
                        resizable: false,
                        allowBlank: !Const.ENABLETYCHY,
                        mode: "local",
                        editable: true,
                        fieldLabel: Lang.typ_taboru,
                        hidden: !Const.ENABLETYCHY
                    }, {
                        id: this.cid + "markapojazdu",
                        name: "markapojazdu",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.marka_pojazdu,
                        allowBlank: true,
                        hidden: !Const.ENABLETYCHY
                    }, {
                        id: this.cid + "createinfo",
                        name: "createinfo",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.utworzono,
                        allowBlank: true,
                        editable: false,
                        hidden: Const.ENABLEKELLER
                    }, {
                        id: this.cid + "closeinfo",
                        name: "closeinfo",
                        xtype: 'textfieldexd',
                        fieldLabel: Lang.zamkniete,
                        allowBlank: true,
                        editable: false,
                        hidden: !Const.ENABLETYCHY || Const.ENABLEKELLER
                    }, {
                        flex: 1,
                        id: this.cid + 'stanlicznika',
                        isFormField: false,
                        xtype: 'button',
                        text: Lang.popraw_stan_licznika_ostatniego_tankowania,
                        scope: this,
                        handler: () => this.showStanLicznika(false),
                        hidden: Const.STARTERFLAG,
                        style: {
                            margin: '0px 0px 15px 0px'
                        },
                    }, {
                        flex: 1,
                        id: this.cid + 'stanlicznika2',
                        isFormField: false,
                        xtype: 'button',
                        text: Lang.ustal_aktualny_stan_licznika,
                        scope: this,
                        handler: () => this.showStanLicznika(true),
                        hidden: !Const.ENTERPRISEFLAG && !Const.PROFLAG && !Const.ULTIMATEFLAG,
                    }]
                }]
            }]
        };
        let identyfikatorpanel = {
            xtype: 'identyfikatorpanel',
            fieldLabel: Lang.identyfikator,
            labelAlign: 'left',
            id: this.cid + "identpanel"
        };
        let opis = {
            anchor: "0",
            fieldLabel: Lang.opis,
            isFormField: true,
            id: this.cid + "opis",
            name: "opis",
            xtype: 'textarea'
        };
        let panelstanczytnika = {
            id: this.cid + "panelstanczytnika",
            xtype: "panelstanczytnikaexd"
        };
        if (WindowExdMobileDEVICEV)
            formpanel1.items[0].items[0].items.push(identyfikatorpanel, opis, panelstanczytnika);
        else {
            formpanel1.items[0].items.push({
                columnWidth: 0.3,
                layout: 'anchor',
                frame: false,
                border: false,
                defaults: {
                    anchor: "0",
                    labelWidth: 130
                },
                bodyStyle: 'padding-left: 15px; padding-top: 7.5px',
                items: [identyfikatorpanel]
            });
            formpanel1.items.push({
                anchor: "0",
                layout: 'column',
                frame: false,
                border: false,
                isFormField: false,
                items: [{
                    columnWidth: 0.7,
                    layout: 'anchor',
                    frame: false,
                    border: false,
                    isFormField: false,
                    height: 150,
                    style: "margin-top:10px",
                    defaults: {
                        anchor: "0"
                    },
                    items: [opis]
                }, {
                    style: "margin-left:15px;",
                    columnWidth: .3,
                    xtype: 'container',
                    layout: 'anchor',
                    cls: "x-ident-main-border2",
                    height: 150,
                    id: this.cid + "identpanelct",
                    items: [panelstanczytnika]
                }]
            });
        }
        let form5 = {
            title: Lang.stany_licznika.capitalise(),
            xtype: 'form',
            id: this.cid + 'formpanel5',
            bodyStyle: 'padding:10px 10px 10px 10px',
            frame: true,
            scrollable: true,
            autoWidth: true,
            defaults: {
                anchor: "0"
            },
            items: [{
                anchor: "0",
                layout: {
                    type: 'table',
                    columns: WindowExdMobileDEVICEV ? 1 : 2,
                    tableAttrs: {
                        style: {
                            width: '100%',
                            valign: 'top'
                        }
                    },
                    tdAttrs: {
                        style: {
                            verticalAlign: 'top'
                        }
                    }
                },
                border: false,
                items: [{
                    border: false,
                    layout: 'anchor',
                    labelWidth: 110,
                    defaults: {
                        anchor: "0",
                        labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left'
                    },
                    items: [{
                        id: this.cid + "stanlicznikaczasstart",
                        name: "stanlicznikaczasstart",
                        xtype: 'textfield',
                        fieldLabel: Lang.czas,
                        allowBlank: true,
                        disabled: true,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "stanlicznikaoperatorstart",
                        name: "stanlicznikaoperatorstart",
                        xtype: 'textfield',
                        fieldLabel: Lang.operator,
                        allowBlank: true,
                        disabled: true,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "stanlicznikastart",
                        name: "stanlicznikastart",
                        xtype: 'numberfield',
                        fieldLabel: Lang.poczatkowy_stan_licznika,
                        allowBlank: true,
                        disabled: AppOPERATORHPOZIOM > 1,
                        maxLength: 64,
                        blankText: Lang.pole_nie_moze_byc_puste
                    }, {
                        id: this.cid + "photostart",
                        xtype: 'image',
                        src: '',
                        style: {
                            width: '350px',
                            height: '300px',
                            maxWidth: '100%',
                            maxHeight: '100%',
                            border: '1px solid gray',
                            objectFit: 'contain',
                            display: 'block'
                        }
                    }, {
                        id: this.cid + "pobierzstart",
                        xtype: 'button',
                        iconAlign: 'left',
                        text: Lang.pobierz.capitalise(),
                        maxWidth: 100,
                        disabled: true,
                        scope: this,
                        style: {
                            margin: '15px 0px 0px 0px'
                        },
                        handler: function () {
                            if (this.obiektsource != null) {
                                var link = document.createElement("a");
                                link.setAttribute("href", this.obiektsource.stanlicznikaphotostart);
                                link.setAttribute("download", 'stan_licznika_start');
                                link.click();
                            }
                        },
                        cls: 'x-btn-mobile'
                    }]
                }]
            }]
        }
        let form5rightfields = [{
            id: this.cid + "stanlicznikaczasend",
            name: "stanlicznikaczasend",
            xtype: 'textfield',
            fieldLabel: Lang.czas,
            allowBlank: true,
            disabled: true,
            maxLength: 64,
            blankText: Lang.pole_nie_moze_byc_puste
        }, {
            id: this.cid + "stanlicznikaoperatorend",
            name: "stanlicznikaoperatorend",
            xtype: 'textfield',
            fieldLabel: Lang.operator,
            allowBlank: true,
            disabled: true,
            maxLength: 64,
            blankText: Lang.pole_nie_moze_byc_puste
        }, {
            id: this.cid + "stanlicznikaend",
            name: "stanlicznikaend",
            xtype: 'numberfield',
            fieldLabel: Lang.koncowy_stan_licznika,
            allowBlank: true,
            disabled: AppOPERATORHPOZIOM > 1,
            maxLength: 64,
            blankText: Lang.pole_nie_moze_byc_puste
        }, {
            id: this.cid + "photoend",
            xtype: 'image',
            src: '',
            html: "Empty",
            style: {
                width: '350px',
                height: '300px',
                maxWidth: '100%',
                maxHeight: '100%',
                border: '1px solid gray',
                objectFit: 'contain',
                display: 'block'
            }
        }, {
            id: this.cid + "pobierzend",
            xtype: 'button',
            iconAlign: 'left',
            text: Lang.pobierz.capitalise(),
            disabled: true,
            maxWidth: 100,
            scope: this,
            style: {
                margin: '15px 0px 0px 0px'
            },
            handler: function () {
                if (this.obiektsource != null) {
                    var link = document.createElement("a");
                    link.setAttribute("href", this.obiektsource.stanlicznikaphotoend);
                    link.setAttribute("download", 'stan_licznika_end');
                    link.click();
                }
            },
            cls: 'x-btn-mobile'
        }];
        if (WindowExdMobileDEVICEV)
            form5.items[0].items[0].items.push(...form5rightfields);
        else
            form5.items[0].items.push({
                layout: 'anchor',
                labelWidth: 110,
                border: false,
                defaults: {
                    anchor: "0"
                },
                items: [...form5rightfields]
            });
        this.items = [{
            xtype: 'tabpanel',
            autoWidth: true,
            height: 655,
            border: false,
            deferredRender: false,
            activeTab: 0,
            items: [formpanel1, {
                id: this.cid + "formpanel2",
                title: Lang.zaawansowane,
                xtype: 'form',
                frame: true,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                labelWidth: 80,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0",
                    labelWidth: 80
                },
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1,
                        layout: 'anchor',
                        frame: false,
                        border: false,
                        defaults: {
                            anchor: "0",
                            labelWidth: 130,
                            labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left'
                        },
                        items: [{
                            id: this.cid + "fueltanklimit",
                            name: "fueltanklimit",
                            xtype: 'numberfieldexd',
                            fieldLabel: Lang.pojemnosc_baku_paliwa,
                            decimalPrecision: 2,
                            minValue: 0,
                            // allowBlank: false,
                            // blankText: Lang.pole_nie_moze_byc_puste,
                            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "controlfueltanklimit",
                            name: "controlfueltanklimit",
                            baseCls: 'x-radio-column',
                            fieldLabel: Lang.limit_pojemnosci_baku,
                            columns: 2,
                            vertical: false,
                            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                            items: [{
                                boxLabel: Lang.tak.capitalise(),
                                inputValue: true,
                                value: true
                            }, {
                                boxLabel: Lang.nie.capitalise(),
                                inputValue: false
                            }]
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "canviewtankowanie",
                            name: "canviewtankowanie",
                            baseCls: 'x-radio-column',
                            fieldLabel: Lang.podglad_tankowania,
                            columns: 2,
                            vertical: false,
                            items: [{
                                boxLabel: Lang.tak.capitalise(),
                                inputValue: true,
                                value: true
                            }, {
                                boxLabel: Lang.nie.capitalise(),
                                inputValue: false
                            }],
                            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "cansetaddpole",
                            name: "cansetaddpole",
                            fieldLabel: Lang.pole_dodatkowe_przy_tankowaniu,
                            columns: 2,
                            vertical: false,
                            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                            items: [{
                                boxLabel: Lang.tak.capitalise(),
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie.capitalise(),
                                inputValue: false,
                                value: true
                            }]
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "askforvolumetank",
                            name: "askforvolumetank",
                            baseCls: 'x-radio-column',
                            fieldLabel: Lang.pytanie_o_ilosc_dozatankowania,
                            columns: 2,
                            vertical: false,
                            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                            items: [{
                                boxLabel: Lang.tak,
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie,
                                inputValue: false,
                                value: true
                            }]
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "zbiornikmobilnystatus",
                            name: "zbiornikmobilnystatus",
                            baseCls: 'x-radio-column',
                            fieldLabel: Lang.zbiornik_mobilny_status,
                            columns: 2,
                            vertical: false,
                            items: [{
                                boxLabel: Lang.tak.capitalise(),
                                inputValue: true,
                                value: true
                            }, {
                                boxLabel: Lang.nie.capitalise(),
                                inputValue: false
                            }],
                            listeners: {
                                scope: this,
                                change: function (radiogroup, newValue) {
                                    Ext.getCmp(this.cid + "idzbiornikmobilny").setHidden(!newValue);
                                }
                            },
                            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
                        }, {
                            id: this.cid + "idzbiornikmobilny",
                            name: "idzbiornikmobilny",
                            style: "margin-top: 10px",
                            fieldLabel: Lang.polaczony_zbiornik,
                            allowBlank: true,
                            xtype: 'comboexd',
                            emptyText: Lang.brak_zbiornika,
                            store: new Ext.data.Store({
                                autoLoad: false,
                                proxy: {
                                    type: "ajax",
                                    url: "rest/zbiorniki/getList",
                                    actionMethods: {
                                        read: 'GET'
                                    },
                                    reader: new Ext.data.JsonReader({
                                        id: "id",
                                        rootProperty: ''
                                    }, [{
                                        name: 'nazwa',
                                        mapping: 'nazwa'
                                    }])
                                }
                            }),
                            columns: [{
                                header: Lang.nazwa,
                                flex: 1,
                                width: 145,
                                sortable: true,
                                dataIndex: 'nazwa'
                            }],
                            displayField: 'nazwa',
                            valueField: 'id',
                            hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
                        }]
                    }]
                }]
            }, {
                id: this.cid + "limpanel",
                title: Lang.limity.capitalise(),
                frame: true,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                hidden: Const.SKPFLAG || Const.BASICFLAG || Const.STARTERFLAG,
                defaults: {
                    anchor: "0",
                    labelWidth: 80
                },
                items: [{
                    id: this.cid + 'limitnotice',
                    xtype: 'displayfield',
                    value: Lang.limity_wylacznie_online,
                    fieldStyle: 'color: red; text-align: center;',
                    hidden: !Const.STANDARDFLAG,
                    height: 40
                }, Ext.create('LimitPanelCp', {
                    hidden: Const.SKPFLAG || (Const.BASICFLAG && Const.CUSTOMMODFLAG != 'swimer' && Const.CUSTOMMODFLAG != 'external_sibuso') || Const.STARTERFLAG,
                    frame: false,
                    border: false,
                    id: this.cid + "limitpanel",
                    height: WindowExdMobileDEVICEV ? '100%' : 497 - (Const.STANDARDFLAG ? 50 : 0),
                    parentObj: this,
                    header: false
                })]
            }, {
                id: this.cid + "formpanel3",
                title: Lang.normy_zuzycia.capitalise(),
                xtype: 'form',
                frame: true,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                labelWidth: 80,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0",
                    labelWidth: 80
                },
                hidden: (Const.BASICFLAG && Const.CUSTOMMODFLAG != 'swimer' && Const.CUSTOMMODFLAG != 'external_sibuso') || Const.STARTERFLAG,
                items: [{
                    anchor: "0",
                    xtype: 'panel',
                    id: this.cid + "normypanel",
                    layout: 'form'
                }]
            }, {
                id: this.cid + "formpanel4",
                title: Lang.ustawienia_indywidualne,
                xtype: 'form',
                frame: true,
                border: false,
                autoWidth: true,
                scrollable: true,
                autoHeight: true,
                hidden: Const.OPTIMALFLAG || Const.BASICFLAG || Const.STANDARDFLAG || Const.STARTERFLAG,
                labelWidth: 80,
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: "0",
                    labelWidth: 80
                },
                items: [{
                    anchor: "0",
                    layout: 'column',
                    frame: false,
                    border: false,
                    items: [{
                        columnWidth: 1,
                        layout: 'anchor',
                        frame: false,
                        border: false,
                        defaults: {
                            anchor: "0",
                            labelWidth: 130,
                            labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left'
                        },
                        items: [{
                            xtype: 'radiogroupexd',
                            id: this.cid + "individualopts",
                            name: "individualopts",
                            fieldLabel: Lang.ustawienia_indywidualne,
                            columns: 2,
                            vertical: false,
                            items: [{
                                boxLabel: Lang.tak,
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie,
                                inputValue: false,
                                value: true
                            }],
                            listeners: {
                                change: function (radiogroup, newValue) {
                                    Ext.getCmp(this.cid + "ident_tryb").setDisabled(!newValue);
                                    Ext.getCmp(this.cid + "ident_pojqq").setDisabled(!newValue);
                                    var mustsetlicznikstate = Ext.getCmp(this.cid + "mustsetlicznikstate");
                                    var mustsetlicznikstatecontrol = Ext.getCmp(this.cid + "mustsetlicznikstatecontrol");
                                    mustsetlicznikstate.setDisabled(!newValue);
                                    if (!newValue) {
                                        mustsetlicznikstate.setValue(false);
                                        mustsetlicznikstate.fireEvent("change", mustsetlicznikstate, mustsetlicznikstate.getValue2());
                                        mustsetlicznikstatecontrol.setValue(false);
                                        mustsetlicznikstatecontrol.fireEvent("change", mustsetlicznikstatecontrol, mustsetlicznikstatecontrol.getValue2());
                                    }
                                    Ext.getCmp(this.cid + "controlmileagediff").setDisabled(!newValue || !mustsetlicznikstatecontrol.getValue2());
                                    Ext.getCmp(this.cid + "maxmileagediff").setDisabled(!Ext.getCmp(this.cid + "controlmileagediff").getValue2() || !newValue);
                                },
                                scope: this
                            },
                            hidden: Const.SKPFLAG
                        }, {
                            id: this.cid + 'ident_tryb',
                            xtype: 'comboexd',
                            store: [[Const.IDENT_PODWOJNA, Lang.podwojna], [Const.IDENT_POJEDYNCZA, Lang.pojedyncza]],
                            triggerAction: 'all',
                            resizable: false,
                            mode: "local",
                            editable: false,
                            disabled: true,
                            fieldLabel: Lang.tryb_identyfikacji,
                            hidden: Const.SKPFLAG
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "ident_pojqq",
                            name: "ident_pojqq",
                            fieldLabel: Lang.pytanie_o_nazwe,
                            columns: 2,
                            vertical: false,
                            disabled: true,
                            items: [{
                                boxLabel: Lang.tak,
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie,
                                inputValue: false,
                                value: true
                            }],
                            hidden: Const.SKPFLAG
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "mustsetlicznikstate",
                            name: "mustsetlicznikstate",
                            fieldLabel: Lang.wymagalnosc_stanu_licznika,
                            columns: 2,
                            vertical: false,
                            disabled: true,
                            items: [{
                                boxLabel: Lang.tak,
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie,
                                inputValue: false,
                                value: true
                            }],
                            listeners: {
                                scope: this,
                                change: function (radiogroup, newValue) {
                                    var mustsetlicznikstatecontrol = Ext.getCmp(this.cid + "mustsetlicznikstatecontrol");
                                    if (!newValue) {
                                        mustsetlicznikstatecontrol.setValue(false);
                                        mustsetlicznikstatecontrol.fireEvent("change", mustsetlicznikstatecontrol, mustsetlicznikstatecontrol.getValue2());
                                    }
                                    mustsetlicznikstatecontrol.setDisabled(!newValue);
                                }
                            },
                            hidden: Const.SKPFLAG
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "mustsetlicznikstatecontrol",
                            name: "mustsetlicznikstatecontrol",
                            fieldLabel: Lang.kontrola_stanu_licznika,
                            columns: 2,
                            vertical: false,
                            disabled: true,
                            items: [{
                                boxLabel: Lang.tak,
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie,
                                inputValue: false,
                                value: true
                            }],
                            listeners: {
                                scope: this,
                                change: function (radiogroup, newValue) {
                                    var controlmileagediff = Ext.getCmp(this.cid + "controlmileagediff");
                                    if (!newValue) {
                                        controlmileagediff.setValue(false);
                                        controlmileagediff.fireEvent("change", controlmileagediff, controlmileagediff.getValue2());
                                    }
                                    controlmileagediff.setDisabled(!newValue);
                                }
                            },
                            hidden: Const.SKPFLAG
                        }, {
                            xtype: 'radiogroupexd',
                            id: this.cid + "controlmileagediff",
                            name: "controlmileagediff",
                            fieldLabel: Lang.kontrola_roznicy_przebiegu,
                            columns: 2,
                            vertical: false,
                            disabled: true,
                            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG || this.vvtype == "odbiorca",
                            items: [{
                                boxLabel: Lang.tak.capitalise(),
                                inputValue: true
                            }, {
                                boxLabel: Lang.nie.capitalise(),
                                inputValue: false,
                                value: true
                            }],
                            listeners: {
                                change: function (radiogroup, newValue) {
                                    var maxmileagediff = Ext.getCmp(this.cid + "maxmileagediff");
                                    if (!newValue) {
                                        maxmileagediff.setValue(null);
                                    }
                                    maxmileagediff.setDisabled(!newValue);
                                },
                                scope: this
                            }
                        }, {
                            id: this.cid + "maxmileagediff",
                            name: "maxmileagediff",
                            xtype: 'numberfieldexd',
                            fieldLabel: Lang.maksymalna_roznica_przebiegu,
                            allowBlank: false,
                            disabled: true,
                            decimalPrecision: 2,
                            minValue: 0,
                            cls: "x-item-disabled-sec",
                            hidden: Const.BASICFLAG || Const.OPTIMALFLAG || Const.STANDARDFLAG || Const.STARTERFLAG
                        }]
                    }]
                }]
            }]
        }];
        if (Const.ENABLEKELLER) {
            this.items[0].items.push(form5);
        }
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showStanLicznika: function (onlyPojazd) {
        var windowPojazdLicznik = Ext.create('WindowPojazdLicznik', {
            dane: {
                onlyPojazd: onlyPojazd,
                pojazdid: this.obiektid,
                stanlicznika: this.obiekt["stanlicznika"],
                lastupdate: this.obiekt["stanlicznikalastupdate"]
            },
            parentObj: this
        });
        windowPojazdLicznik.showW();
        windowPojazdLicznik.on("wclose", function (stanLicznika) {
            this.obiekt["stanlicznika"] = stanLicznika;
        }, this);
    },
    showStanLicznikaKeller: function (isstart) {
        var windowStanyLicznika = Ext.create('WindowStanyLicznika', {
            isstart: isstart,
            typwlasnosci: this.wynajem,
            parentObj: this
        });
        windowStanyLicznika.show();
        windowStanyLicznika.on("wclose", function (stanLicznika, photobase64) {
            isstart ? Ext.getCmp(this.cid + "stanlicznikastart").setValue(stanLicznika) : Ext.getCmp(this.cid + "stanlicznikaend").setValue(stanLicznika);
            isstart ? this.photostart = photobase64 : this.photoend = photobase64;
            this.isstanylicznikafilled = (stanLicznika != null && photobase64 != null) || !this.wynajem;
            this.mask(Lang.ladowanie);
            this.saveOp();
        }, this);
        windowStanyLicznika.on("eclose", function () {
            this.unmask();
        }, this);
    },
    showW: function (obiektid, klonowanie) {
        if (!validPrivilegesOperatorComplex("access.manage.pojazdy") && !validPrivilegesOperatorComplex("access.manage.pojazdy_wynajem")) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiektid = obiektid;
        this.obiekt = null;
        this.obiektsource = null;
        this.defaultMaxMileageDiff = null;
        this.klonowanie = klonowanie || false;
        sendAjaxDataJsonRpcLGroup(["rest/pojazdy/getObjectForEdit", "rest/plyny/getShortList"], [{
            id: this.obiektid
        }, null], this, function (gstatus, data, datad, status) {
            if (gstatus) {
                this.obiekt = datad[0];
                this.obiektsource = datad[0];
                sendAjaxDataJsonRpcL("rest/firmy/getObjectForEdit", {
                    id: this.obiekt != null ? this.obiekt.idfirma : (AppFIRMACTX != null) ? AppFIRMACTX.id : 1
                }, this, function (firmadata) {
                    if (firmadata.status) {
                        this.show();
                        this.center();
                        this.setKeyMap({
                            'ESC': {
                                scope: this,
                                handler: this.closeOp
                            }
                        });
                        Ext.getCmp(this.cid + "nazwa").setValue(null);
                        Ext.getCmp(this.cid + "nazwa").clearInvalid();
                        Ext.getCmp(this.cid + "eiid").setValue(null);
                        Ext.getCmp(this.cid + "eiid").clearInvalid();
                        Ext.getCmp(this.cid + "cardname").setValue(null);
                        Ext.getCmp(this.cid + "cardname").clearInvalid();
                        Ext.getCmp(this.cid + "rokprodukcji").setValue(null);
                        Ext.getCmp(this.cid + "rokprodukcji").clearInvalid();
                        Ext.getCmp(this.cid + "identeuro").setValue(null);
                        Ext.getCmp(this.cid + "identeuro").clearInvalid();
                        Ext.getCmp(this.cid + "active").setValue2(true);
                        Ext.getCmp(this.cid + "zbiornikmobilnystatus").setValue2(false);
                        Ext.getCmp(this.cid + "idzbiornikmobilny").setValue(false);
                        Ext.getCmp(this.cid + "opis").setValue(null);
                        Ext.getCmp(this.cid + "canviewtankowanie").setValue2(!this.wynajem);
                        Ext.getCmp(this.cid + "cansetaddpole").setValue2(false);
                        Ext.getCmp(this.cid + "askforvolumetank").setValue2(!this.wynajem);
                        Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setValue2(false);
                        if (Const.ENABLEKELLER) {
                            Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setValue2(true);
                        }
                        Ext.getCmp(this.cid + "fueltanklimit").setValue(null);
                        Ext.getCmp(this.cid + "fueltanklimit").clearInvalid();
                        Ext.getCmp(this.cid + "controlfueltanklimit").setValue2(false);
                        Ext.getCmp(this.cid + "identflota").setValue(null);
                        Ext.getCmp(this.cid + "identflota").clearInvalid();
                        Ext.getCmp(this.cid + "localization").setValue(null);
                        Ext.getCmp(this.cid + "localization").clearInvalid();
                        if (Const.ENABLETYCHY) {
                            Ext.getCmp(this.cid + "markapojazdu").setValue(null);
                            Ext.getCmp(this.cid + "markapojazdu").clearInvalid();
                            Ext.getCmp(this.cid + "typpojazdu").setValue(null);
                            Ext.getCmp(this.cid + "typpojazdu").clearInvalid();
                            Ext.getCmp(this.cid + "typtaboru").setValue(null);
                            Ext.getCmp(this.cid + "typtaboru").clearInvalid();
                        }
                        this.normals = [];
                        Ext.getCmp(this.cid + 'stanlicznika').setVisible(false);
                        var firma = firmadata.data;
                        if (firma != null) {
                            if (firma.maxmileagediffkm > 0 || firma.maxmileagediffrg > 0) {
                                this.defaultMaxMileageDiff = {
                                    km: firma.maxmileagediffkm,
                                    rg: firma.maxmileagediffrg
                                };
                            }
                        }
                        this.plynls = datad[1];
                        if (Ext.getCmp(this.cid + "plyn")) {
                            Ext.getCmp(this.cid + "plyn").getStore().insert(0, [{
                                nazwa: Lang.brak_plynu,
                                id: null
                            }]);
                            for (i = 0; i < this.plynls.length; i++) {
                                Ext.getCmp(this.cid + "plyn").getStore().insert(i + 1, [{
                                    nazwa: this.plynls[i].nazwa,
                                    id: this.plynls[i].id
                                }]);
                            }
                        }
                        if (this.obiekt != null) {
                            if (this.klonowanie) {
                                this.obiektsource.nazwa = null;
                                this.obiektsource.eiid = null;
                                this.obiektid = 0;
                                this.obiekt = null;
                            }
                            this.limitydatas = this.obiektsource.limitydatas;
                            Ext.getCmp(this.cid + 'limitpanel').setLimitList(this.limitydatas);
                            this.normals = this.obiektsource.normals;
                            Ext.getCmp(this.cid + "nazwa").setValue(this.obiektsource.nazwa);
                            Ext.getCmp(this.cid + "eiid").setValue(this.obiektsource.eiid);
                            Ext.getCmp(this.cid + "cardname").setValue(this.obiektsource.cardname);
                            Ext.getCmp(this.cid + "rokprodukcji").setValue(this.obiektsource.rokprodukcji);
                            Ext.getCmp(this.cid + "identeuro").setValue(this.obiektsource.identeuro);
                            Ext.getCmp(this.cid + "active").setValue2(this.obiektsource.active);
                            if (Const.ENABLEKELLER) {
                                Ext.getCmp(this.cid + "identeuro2").setValue(this.obiektsource.identeuro);
                                this.wynajem = this.obiektsource.typwlasnosci == Const.TYP_WLASNOSCI_POJAZDU_WYNAJEM;
                                if (!this.obiektsource.active) {
                                    Ext.getCmp(this.cid + "active").setDisabled(true);
                                }
                                if (this.wynajem) {
                                    Ext.getCmp(this.cid + 'eiid').setDisabled(AppOPERATORHPOZIOM > 1);
                                    Ext.getCmp(this.cid + 'cardname').setHidden(false);
                                    Ext.getCmp(this.cid + 'cardname').setDisabled(AppOPERATORHPOZIOM > 1);
                                }
                                Ext.getCmp(this.cid + 'formpanel5').setDisabled(false);
                                Ext.getCmp(this.cid + 'stanlicznikastart').setValue(this.obiektsource.stanlicznikastart);
                                Ext.getCmp(this.cid + 'stanlicznikaend').setValue(this.obiektsource.stanlicznikaend);
                                Ext.getCmp(this.cid + 'stanlicznikaczasstart').setValue(this.obiektsource.stanlicznikaczasstart);
                                Ext.getCmp(this.cid + 'stanlicznikaczasend').setValue(this.obiektsource.stanlicznikaczasend);
                                Ext.getCmp(this.cid + 'stanlicznikaoperatorstart').setValue(this.obiektsource.stanlicznikaoperatorstart);
                                Ext.getCmp(this.cid + 'stanlicznikaoperatorend').setValue(this.obiektsource.stanlicznikaoperatorend);
                                Ext.getCmp(this.cid + 'photostart').setSrc(this.obiektsource.stanlicznikaphotostart);
                                Ext.getCmp(this.cid + 'kategoria').setDisabled(AppOPERATORHPOZIOM > 1);
                                if (this.obiektsource.stanlicznikaphotostart != null) {
                                    Ext.getCmp(this.cid + 'pobierzstart').setDisabled(false);
                                }
                                Ext.getCmp(this.cid + 'photoend').setSrc(this.obiektsource.stanlicznikaphotoend);
                                if (this.obiektsource.stanlicznikaphotoend != null) {
                                    Ext.getCmp(this.cid + 'pobierzend').setDisabled(false);
                                }
                                if (this.wynajem && AppOPERATORHPOZIOM > 1) {
                                    Ext.getCmp(this.cid + 'formpanel2').setDisabled(true);
                                    Ext.getCmp(this.cid + 'formpanel3').setDisabled(true);
                                    Ext.getCmp(this.cid + 'formpanel4').setDisabled(true);
                                    Ext.getCmp(this.cid + 'formpanel5').setDisabled(true);
                                    Ext.getCmp(this.cid + 'limpanel').setDisabled(true);
                                    Ext.getCmp(this.cid + 'rokprodukcji').setHidden(true);
                                    Ext.getCmp(this.cid + 'identflota').setHidden(true);
                                    Ext.getCmp(this.cid + 'nazwa').setDisabled(true);
                                    Ext.getCmp(this.cid + 'identeuro2').setDisabled(true);
                                    Ext.getCmp(this.cid + 'grupa').setDisabled(true);
                                    Ext.getCmp(this.cid + 'ismotogodzinynotkilometry').setDisabled(true);
                                    Ext.getCmp(this.cid + 'stanlicznika').setDisabled(true);
                                    Ext.getCmp(this.cid + 'identpanel').setDisabled(true);
                                }
                            }
                            var idzbiornikmobilny = this.obiektsource.idzbiornikmobilny;
                            Ext.getCmp(this.cid + "zbiornikmobilnystatus").setValue2(idzbiornikmobilny != null);
                            Ext.getCmp(this.cid + "idzbiornikmobilny").setValue(idzbiornikmobilny);
                            Ext.getCmp(this.cid + "idzbiornikmobilny").setHidden(idzbiornikmobilny == null);
                            Ext.getCmp(this.cid + "opis").setValue(this.obiektsource.opis);
                            Ext.getCmp(this.cid + "askforvolumetank").setValue2(this.obiektsource.askforvolumetank);
                            Ext.getCmp(this.cid + "canviewtankowanie").setValue2(this.obiektsource.canviewtankowanie);
                            Ext.getCmp(this.cid + "cansetaddpole").setValue2(this.obiektsource.cansetaddpole);
                            Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setValue2(this.obiektsource.ismotogodzinynotkilometry);
                            Ext.getCmp(this.cid + "controlfueltanklimit").setValue2(this.obiektsource.controlfueltanklimit);
                            Ext.getCmp(this.cid + "grupa").getStore().getProxy().setExtraParam('firma', this.obiektsource.idfirma);
                            Ext.getCmp(this.cid + "grupa").setValue(this.obiektsource.idgrupa);
                            Ext.getCmp(this.cid + "kategoria").getStore().getProxy().setExtraParam('firma', this.obiektsource.idfirma);
                            Ext.getCmp(this.cid + "kategoria").setValue(this.obiektsource.idkategoria);
                            Ext.getCmp(this.cid + "plyn").setValue(this.obiektsource.idplyn);
                            Ext.getCmp(this.cid + "fueltanklimit").setValue(this.obiektsource.fueltanklimit);
                            Ext.getCmp(this.cid + "ident_tryb").setValue(this.obiektsource.ident_tryb);
                            Ext.getCmp(this.cid + "ident_pojqq").setValue2(this.obiektsource.ident_pojqq);
                            Ext.getCmp(this.cid + "createinfo").setValue(this.obiektsource.createinfo);
                            if (Const.ENABLETYCHY) {
                                Ext.getCmp(this.cid + "typpojazdu").setValue2(this.obiektsource.typpojazdu);
                                Ext.getCmp(this.cid + "typtaboru").setValue2(this.obiektsource.typtaboru);
                                Ext.getCmp(this.cid + "markapojazdu").setValue2(this.obiektsource.markapojazdu);
                                Ext.getCmp(this.cid + "typpojazdu").setDisabled(true);
                                Ext.getCmp(this.cid + "typtaboru").setDisabled(this.obiektsource.typpojazdu == Const.TYP_POJAZDU_ZEWNETRZNY);
                                Ext.getCmp(this.cid + "active").setDisabled(false);
                                if (Const.TYP_POJAZDU_ZEWNETRZNY != this.obiektsource.typpojazdu || this.obiektsource.closeinfo == null) {
                                    Ext.getCmp(this.cid + "closeinfo").setHidden(true);
                                } else {
                                    Ext.getCmp(this.cid + "closeinfo").setValue(this.obiektsource.closeinfo);
                                }
                            }
                            Ext.getCmp(this.cid + "mustsetlicznikstate").setValue2(this.obiektsource.mustsetlicznikstate);
                            Ext.getCmp(this.cid + "mustsetlicznikstatecontrol").setValue2(this.obiektsource.mustsetlicznikstatecontrol);
                            Ext.getCmp(this.cid + "identflota").setValue(this.obiektsource.identflota);
                            Ext.getCmp(this.cid + "localization").setValue(this.obiektsource.localization);
                            if (this.obiektsource.maxmileagediff > 0) {
                                Ext.getCmp(this.cid + "maxmileagediff").setValue(this.obiektsource.maxmileagediff);
                                Ext.getCmp(this.cid + "controlmileagediff").setValue2(true);
                            }
                            this.identPanel = Ext.getCmp(this.cid + "identpanel");
                            this.identPanel.init({
                                obiektid: obiektid,
                                objectt: "pojazd",
                                object: this.obiekt,
                                readerPanel: Ext.getCmp(this.cid + 'panelstanczytnika')
                            });
                            if (Const.ENABLEKELLER && this.wynajem) {
                                this.identPanel.setDisabled(true);
                                var panelstanczytnika = Ext.getCmp(this.cid + 'panelstanczytnika');
                                panelstanczytnika.setHidden(true);
                                panelstanczytnika.onIdentPut = function (czytnik, karta) {
                                    //do nothing
                                }
                            }
                            Ext.getCmp(this.cid + 'stanlicznika').setVisible(!Const.STARTERFLAG);
                        } else {
                            Ext.getCmp(this.cid + "createinfo").setHidden(true);
                            if (firma != null && !this.wynajem) {
                                Ext.getCmp(this.cid + "askforvolumetank").setValue2(firma.askforvolumetank);
                            }
                            this.obiektsource = this.obiektsource || {
                                optlockversion: null,
                                ident_tryb: Const.IDENT_PODWOJNA,
                                ident_pojqq: false,
                                mustsetlicznikstate: false,
                                mustsetlicznikstatecontrol: false,
                                individualopts: false
                            };
                            if (Const.ENABLETYCHY) {
                                Ext.getCmp(this.cid + "typpojazdu").setValue2(TYP_POJAZDU[0][0]);
                                Ext.getCmp(this.cid + "typtaboru").setValue2(TYP_TABORU[0][0]);
                                Ext.getCmp(this.cid + "closeinfo").setHidden(true);
                            }
                            var ismotogodzinynotkilometry = Ext.getCmp(this.cid + "ismotogodzinynotkilometry");
                            ismotogodzinynotkilometry.fireEvent("change", ismotogodzinynotkilometry, ismotogodzinynotkilometry.getValue2());
                            this.limitydatas = [];
                            this.identPanel = Ext.getCmp(this.cid + "identpanel");
                            this.identPanel.init({
                                obiektid: obiektid,
                                objectt: "pojazd",
                                readerPanel: Ext.getCmp(this.cid + 'panelstanczytnika')
                            });
                            if (Const.ENABLETRAMWAJE) {
                                Ext.getCmp(this.cid + "active").setValue(false);
                            }
                            if (Const.ENABLEKELLER) {
                                Ext.getCmp(this.cid + 'active').setDisabled(true);
                                Ext.getCmp(this.cid + 'formpanel5').setDisabled(true);
                                if (this.wynajem) {
                                    Ext.getCmp(this.cid + 'formpanel2').setDisabled(true);
                                    Ext.getCmp(this.cid + 'formpanel3').setDisabled(true);
                                    Ext.getCmp(this.cid + 'formpanel4').setDisabled(true);
                                    Ext.getCmp(this.cid + 'limpanel').setDisabled(true);
                                    Ext.getCmp(this.cid + "rokprodukcji").setHidden(true);
                                    Ext.getCmp(this.cid + "identflota").setHidden(true);
                                    Ext.getCmp(this.cid + 'eiid').setDisabled(true);
                                    Ext.getCmp(this.cid + 'cardname').setHidden(false);
                                    var self = this;
                                    this.identPanel.on('changeidentyfikatorevent', function (id) {
                                        sendAjaxDataJsonRpcL("rest/kellerindentkods/tryKellerIdentAssign", {
                                            id: this.obiektid,
                                            identyfikator: id
                                        }, self, function (data) {
                                            if (data.status) {
                                                data = data.data
                                                Ext.getCmp(this.cid + "eiid").setValue(data.eiid);
                                                Ext.getCmp(this.cid + "cardname").setValue(data.nazwa);
                                                // this.identPanel.setDisabled(true);
                                                // var panelstanczytnika = Ext.getCmp(this.cid + 'panelstanczytnika');
                                                // panelstanczytnika.setHidden(true);
                                                // panelstanczytnika.onIdentPut = function (czytnik, karta) {
                                                //     //do nothing
                                                // }
                                            } else {
                                                Ext.MessageBox.alert(Lang.error, data.error);
                                                this.identPanel.markIdAsUsed();
                                                this.identPanel.refreshFkod();
                                            }
                                        }, 0);
                                    });
                                } else {
                                }
                            }
                        }
                        Ext.getCmp(this.cid + 'limitpanel').setLimitList(this.limitydatas);
                        Ext.getCmp(this.cid + "ident_tryb").setValue(this.obiektsource.ident_tryb);
                        Ext.getCmp(this.cid + "ident_pojqq").setValue2(this.obiektsource.ident_pojqq);
                        if (Const.ENABLETYCHY) {
                            Ext.getCmp(this.cid + "markapojazdu").setValue2(this.obiektsource.markapojazdu);
                        }
                        Ext.getCmp(this.cid + "mustsetlicznikstate").setValue2(this.obiektsource.mustsetlicznikstate);
                        Ext.getCmp(this.cid + "mustsetlicznikstatecontrol").setValue2(this.obiektsource.mustsetlicznikstatecontrol || (!this.obiektsource.individualopts && firma.mustsetlicznikstatecontrol));
                        Ext.getCmp(this.cid + "mustsetlicznikstatecontrol").fireEvent("change", Ext.getCmp(this.cid + "mustsetlicznikstatecontrol"), this.obiektsource.mustsetlicznikstatecontrol || (!this.obiektsource.individualopts && firma.mustsetlicznikstatecontrol));
                        var individualOpts = Ext.getCmp(this.cid + "individualopts");
                        individualOpts.setValue2(this.obiektsource.individualopts);
                        individualOpts.fireEvent("change", individualOpts, this.obiektsource.individualopts);
                        Ext.getCmp(this.cid + "grupa").getStore().load({
                            scope: this,
                            callback: function (records, operation, success) {
                                if (Ext.getCmp(this.cid + "grupa")) {
                                    Ext.getCmp(this.cid + "grupa").getStore().insert(0, [{
                                        nazwa: Lang.brak_grupy,
                                        id: null
                                    }]);
                                }
                            }
                        });
                        if (Const.ENABLEKELLER && this.wynajem) {
                            Ext.getCmp(this.cid + "kategoria").getStore().load();
                            Ext.getCmp(this.cid + "kategoria").allowBlank = false;
                        } else {
                            Ext.getCmp(this.cid + "kategoria").getStore().load({
                                scope: this,
                                callback: function (records, operation, success) {
                                    if (Ext.getCmp(this.cid + "kategoria")) {
                                        Ext.getCmp(this.cid + "kategoria").getStore().insert(0, [{
                                            nazwa: Lang.brak_kategorii,
                                            id: null
                                        }]);
                                    }
                                }
                            });
                        }
                        Ext.getCmp(this.cid + "idzbiornikmobilny").getStore().load({
                            scope: this,
                            callback: function (records, operation, success) {
                                if (Ext.getCmp(this.cid + "idzbiornikmobilny")) {
                                    Ext.getCmp(this.cid + "idzbiornikmobilny").getStore().insert(0, [{
                                        nazwa: Lang.brak_zbiornika,
                                        id: null
                                    }]);
                                }
                            }
                        });
                        Ext.suspendLayouts();
                        for (var i = 0; i < this.plynls.length; i++) {
                            var pl = this.plynls[i];
                            var iddl = Ext.id();
                            Ext.getCmp(this.cid + "normypanel").add({
                                anchor: "0",
                                xtype: 'panel',
                                frame: false,
                                border: false,
                                layout: {
                                    type: WindowExdMobileDEVICEV ? 'vbox' : 'hbox',
                                    align: 'stretch'
                                },
                                id: iddl + "panel",
                                bodyStyle: 'padding:0px 0px 5px 0px',
                                items: [{
                                    flex: 1,
                                    margin: "0 5 0 0",
                                    id: iddl + 'plyn',
                                    name: "plyn",
                                    frame: false,
                                    border: false,
                                    xtype: 'displayexd'
                                }, {
                                    flex: 1,
                                    frame: false,
                                    border: false,
                                    margin: "0 5 0 0",
                                    id: iddl + "wartosc",
                                    name: "wartosc",
                                    xtype: 'numberfieldexd',
                                    fieldLabel: Lang.wartosc,
                                    allowBlank: true,
                                    decimalPrecision: 2,
                                    blankText: Lang.pole_nie_moze_byc_puste,
                                    minValue: 0,
                                    maxValue: 9999999
                                }]
                            });
                            var plyn = Ext.getCmp(iddl + "plyn");
                            var wartosc = Ext.getCmp(iddl + "wartosc");
                            plyn.setValue(pl.nazwa);
                            var nn = null;
                            for (var k = 0; k < this.normals.length; k++) {
                                if (this.normals[k].idplyn == pl.id) {
                                    nn = this.normals[k];
                                    nn.elcwartosc = wartosc;
                                    wartosc.setValue(nn.wartosczuzycie1001h);
                                }
                            }
                            if (nn == null) {
                                nn = {
                                    wartosczuzycie1001h: null,
                                    idplyn: pl.id,
                                    elcwartosc: wartosc
                                };
                                this.normals.push(nn);
                            }
                        }
                        Ext.resumeLayouts(true);
                        var title = Const.ENABLEKELLER ? (this.wynajem ? Lang.pojazd_wynajem.capitalise() : Lang.pojazd_wlasny.capitalise()) : Lang.pojazd.capitalise();
                        if (AppFIRMACTX != null)
                            title += " (" + AppFIRMACTX.nazwa + ")";
                        this.setTitle(title);
                    } else {
                        Ext.MessageBox.alert(Lang.error, firmadata.error);
                    }
                });
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        }, function (scopeg, allStatusaOK, dataa, datada, statusa, responseTexta) {
            if (!datada[0]) {
                Ext.MessageBox.alert(Lang.error, statusa[0]);
            }
            if (!datada[1]) {
                Ext.MessageBox.alert(Lang.error, statusa[1]);
            }
        });
    },
    saveOp: function () {
        var canWrite = false;
        if (Ext.getCmp(this.cid + "nazwa").isValid()) {
            canWrite = true;
        }
        if (!this.identPanel.isValid()) {
            if (Ext.getCmp(this.cid + "active").getValue2()) {
                Ext.MessageBox.alert(Lang.error, Lang.obiekt_aktywny_musi_miec_przydzielony_identyfikator);
                return;
            }
        }
        if (!Ext.getCmp(this.cid + 'formpanel1').form.isValid() || !Ext.getCmp(this.cid + 'formpanel2').form.isValid() || !Ext.getCmp(this.cid + 'formpanel3').form.isValid() || !Ext.getCmp(this.cid + 'formpanel4').form.isValid()) {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
            return;
        }
        var msgggp = this.identPanel.isValidOtherErrorIf();
        if (msgggp != null && Ext.getCmp(this.cid + "active").getValue2()) {
            Ext.MessageBox.alert(Lang.error, msgggp);
            return;
        }
        if (canWrite) {
            if (this.obiekt == null && Const.ENABLEKELLER && !this.isstanylicznikafilled) {
                this.showStanLicznikaKeller(true);
                return;
            }
            if (this.obiekt != null && Const.ENABLEKELLER && this.obiekt.active && !Ext.getCmp(this.cid + "active").getValue2() && !this.isstanylicznikafilled) {
                this.showStanLicznikaKeller(false);
                return;
            }
            if (this.obiekt != null && this.obiekt.nazwa != Ext.getCmp(this.cid + "nazwa").getValue()) {
                Ext.MessageBox.show({
                    title: Lang.zmiana_danych_nazwy_nazwy,
                    message: Lang.wykryto_zmiany_nazwy_pojazdu_wybierz_co_chcesz_zrobic,
                    buttons: Ext.Msg.YESNO,
                    buttonText: {
                        yes: Lang.edytuj_mimo_wszystko,
                        no: Lang.zapisz_jako_nowy_pojazd
                    },
                    scope: this,
                    fn: function (btn) {
                        if (btn == "yes") {
                            this.performSave();
                        }
                        if (btn == "no") {
                            sendAjaxDataJsonRpcL("rest/pojazdy/deactivateObject", {
                                id: this.obiektid
                            }, this, function (data) {
                                if (data.status) {
                                    this.obiektid = 0;
                                    this.performSave();
                                } else {
                                    Ext.MessageBox.alert(Lang.error, data.error);
                                }
                            }, 0);
                        }
                    }
                });
            } else {
                this.performSave();
            }
        } else {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
        }
    },
    performSave: function () {
        var vii = this.identPanel.getIdentData();
        var maxMileageDiff = 0;
        if (Ext.getCmp(this.cid + "individualopts").getValue2()) {
            maxMileageDiff = Ext.getCmp(this.cid + "maxmileagediff").getValue();
        } else if (this.defaultMaxMileageDiff) {
            if (Ext.getCmp(this.cid + "ismotogodzinynotkilometry").getValue2()) {
                maxMileageDiff = this.defaultMaxMileageDiff.rg;
            } else {
                maxMileageDiff = this.defaultMaxMileageDiff.km;
            }
        }
        let normalsCopy = [...this.normals];
        for (var k = 0; k < normalsCopy.length; k++) {
            var nn = {...normalsCopy[k]};
            nn.wartosczuzycie1001h = nn.elcwartosc.getValue2();
            delete nn.elcwartosc;
            normalsCopy[k] = nn;
        }
        var zbiornikMobilnyStatus = Ext.getCmp(this.cid + "zbiornikmobilnystatus").getValue2();
        var idzbiornikMobilny = zbiornikMobilnyStatus ? Ext.getCmp(this.cid + "idzbiornikmobilny").getValue2NL() : null;
        var identeuro = Const.ENABLEKELLER ? Ext.getCmp(this.cid + "identeuro2").getValue2NL() : Ext.getCmp(this.cid + "identeuro").getValue();
        var stanlicznikastart = Ext.getCmp(this.cid + "stanlicznikastart") != null ? Ext.getCmp(this.cid + "stanlicznikastart").getValue() : null;
        var stanlicznikaend = Ext.getCmp(this.cid + "stanlicznikaend") != null ? Ext.getCmp(this.cid + "stanlicznikaend").getValue() : null;
        sendAjaxDataJsonRpcL("rest/pojazdy/saveObject", {
            id: this.obiektid,
            nazwa: Ext.getCmp(this.cid + "nazwa").getValue(),
            eiid: Ext.getCmp(this.cid + "eiid").getValue(),
            cardname: Ext.getCmp(this.cid + "cardname").getValue(),
            rokprodukcji: Ext.getCmp(this.cid + "rokprodukcji").getValue(),
            identeuro: identeuro,
            active: Ext.getCmp(this.cid + "active").getValue2(),
            ismotogodzinynotkilometry: Ext.getCmp(this.cid + "ismotogodzinynotkilometry").getValue2(),
            opis: Ext.getCmp(this.cid + "opis").getValue(),
            askforvolumetank: Ext.getCmp(this.cid + "askforvolumetank").getValue2(),
            canviewtankowanie: Ext.getCmp(this.cid + "canviewtankowanie").getValue2(),
            cansetaddpole: Ext.getCmp(this.cid + "cansetaddpole").getValue2(),
            controlfueltanklimit: Ext.getCmp(this.cid + "controlfueltanklimit").getValue2(),
            fueltanklimit: Ext.getCmp(this.cid + "fueltanklimit").getValue(),
            maxmileagediff: maxMileageDiff,
            ident_tryb: Ext.getCmp(this.cid + "ident_tryb").getValue(),
            ident_pojqq: Ext.getCmp(this.cid + "ident_pojqq").getValue2(),
            typpojazdu: Const.ENABLETYCHY ? Ext.getCmp(this.cid + "typpojazdu").getValue2() : null,
            typtaboru: Const.ENABLETYCHY ? Ext.getCmp(this.cid + "typtaboru").getValue2() : null,
            markapojazdu: Const.ENABLETYCHY ? Ext.getCmp(this.cid + "markapojazdu").getValue2() : null,
            mustsetlicznikstate: Ext.getCmp(this.cid + "mustsetlicznikstate").getValue2(),
            mustsetlicznikstatecontrol: Ext.getCmp(this.cid + "mustsetlicznikstatecontrol").getValue2(),
            individualopts: Ext.getCmp(this.cid + "individualopts").getValue2(),
            identyfikator: vii.identyfikator,
            identtype: vii.identtype,
            pin: vii.pin,
            grupa: Ext.getCmp(this.cid + "grupa").getValue2NL(),
            kategoria: Ext.getCmp(this.cid + "kategoria").getValue2NL(),
            typwlasnosci: this.wynajem ? Const.TYP_WLASNOSCI_POJAZDU_WYNAJEM : Const.TYP_WLASNOSCI_POJAZDU_WLASNY,
            plyn: Ext.getCmp(this.cid + "plyn").getValue2NL(),
            idzbiornikmobilny: idzbiornikMobilny,
            optlockversion: this.obiekt == null ? null : this.obiekt.optlockversion,
            identflota: Ext.getCmp(this.cid + "identflota").getValue(),
            localization: Ext.getCmp(this.cid + "localization").getValue(),
            data: {
                limitydatas: Ext.getCmp(this.cid + 'limitpanel').getLimitList(),
                normals: normalsCopy
            },
            stanlicznikastart: stanlicznikastart,
            stanlicznikaend: stanlicznikaend,
            photolicznikstart: this.photostart,
            photolicznikend: this.photoend
        }, this, function (data) {
            this.unmask();
            Ext.getCmp(this.cid + 'save').setDisabled(false);
            if (data.status) {
                data = data.data;
                this.obiektid = data.id;
                this.identPanel.close();
                this.close();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
                if (data.error == Lang.identyfikator_uzywany) {
                    this.identPanel.markIdAsUsed();
                }
                return;
            }
            if (this.callbackF)
                this.callbackF();
        }, 0);
    },
    updateIsmotogodzinynotkilometry: function (combo, newValue) {
        var store = combo.getStore();
        var record;
        store.data.items.forEach(function(rec) {
            if (rec.data.id === newValue) {
                record = rec;
            }
        });
        if (record) {
            var typeValue = record.get('type');
            if (typeValue != null) {
                if (typeValue === Const.TYP_KATEGORII_MOTOGODZINY) {
                    Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setValue2(true);
                    Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setDisabled(true);
                } else if (typeValue === Const.TYP_KATEGORII_KILOMETRY) {
                    Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setValue2(false);
                    Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setDisabled(true);
                } else if (typeValue === Const.TYP_KATEGORII_MANUALNY) {
                    Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setDisabled(false);
                }
            } else {
                Ext.getCmp(this.cid + "ismotogodzinynotkilometry").setDisabled(false);
            }
        }
    },
    closeOp: function () {
        this.identPanel.close();
        this.close();
    }
});
